import { CustomFieldType } from 'src/api/generated';

/**
 * Normalizes DATE custom-field time support to a strict boolean for UI callers.
 *
 * The generated API models are strongly typed, but several form and table
 * callsites still trip `@typescript-eslint/no-unsafe-*` after route/client
 * generation on CI. Centralizing the guard keeps those consumers explicit and
 * makes it easy to remove once the generated/client type flow no longer widens
 * this property at those boundaries.
 */
export const resolveDateCustomFieldIncludeTime = (
  fieldType: CustomFieldType,
  includeTime: boolean | undefined
): boolean => {
  return fieldType === CustomFieldType.DATE && includeTime === true;
};

/**
 * Normalizes custom-field mutation payloads to match the backend contract.
 *
 * The backend only accepts `includeTime` for DATE definitions. Non-date
 * definitions must omit the property entirely instead of sending `false`.
 */
export const buildCustomFieldDefinitionIncludeTimePayload = (
  fieldType: CustomFieldType,
  includeTime: boolean | undefined
): boolean | undefined => {
  if (fieldType !== CustomFieldType.DATE) {
    return undefined;
  }

  return includeTime === true;
};
